"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapRootElement = void 0;

var _react = _interopRequireDefault(require("react"));

var _webPreClient = require("@devsisters/web-pre-client");

var _jsxFileName = "/Users/disjukr/work/web-pre-client/packages/gatsby-plugin-pre-client/gatsby-browser.tsx";

const wrapRootElement = ({
  element
}, {
  endpoint
}) => {
  const client = (0, _webPreClient.createClient)({
    url: endpoint
  });
  return _react.default.createElement(_webPreClient.ClientProvider, {
    value: client,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 14
    },
    __self: void 0
  }, _react.default.createElement(_webPreClient.PreRegistrantProvider, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 15
    },
    __self: void 0
  }, element));
};

exports.wrapRootElement = wrapRootElement;